<template>
    <div>
        <Header></Header>
        <div class="container">
            <headerPanel field="contact" :data="contact" :contactOrg="organization" @editContact="editContact" :permissions="permissions" :user="this.currentUser" :users="this.users" @getContact="getContact"/>
            <div class="row">
                <div class="col-md-3 px-0 border border-radius-4 mcBgDarkGrey">
                    <contactDetailPanel  :type="dataType" :user="currentUser" @editContact="editContact" :data="contact"/>
                </div>
                <div class="col-md-9 pl-0 pl-md-3 mt-3 mt-md-0">
                    <div class="row ml-0 border border-radius-4 mcBgDarkGrey ">
                        <ul class="row w-100 mx-0 crm-modal-header nav dealCenterUl hpx-50 px-3 mincrm-dynamic-tabs border-radius-4"> 
                            <li class="w-auto text-center bg-crm-tab"> 
                                <a class="active" href="#organizationAll" data-toggle="tab" role="tab" aria-controls="tab" aria-expanded="true">{{$ml.get('SUMMARY')}}</a> 
                            </li>
                            <li class="w-auto text-center bg-crm-tab"> 
                                <a href="#contactDetailPanel" data-toggle="tab" role="tab" aria-controls="tab" aria-expanded="true">{{$ml.get('COMPANY')}}</a> 
                            </li>  
                            <li class="w-auto text-center bg-crm-tab"> 
                                <a href="#dealDetailPanel" data-toggle="tab" role="tab" aria-controls="tab" aria-expanded="true">{{$ml.get('OPPORTUNITIES')}}</a> 
                            </li>   
                            <li class="w-auto text-center bg-crm-tab"> 
                                <a href="#activitiesDetailPanel" data-toggle="tab" role="tab" aria-controls="tab" aria-expanded="true">{{$ml.get('ACTIVITIES')}}</a> 
                            </li>   
                            <li class="w-auto text-center bg-crm-tab dNoneMobil"> 
                                <a href="#processesDetailPanel" data-toggle="tab" role="tab" aria-controls="tab" aria-expanded="true">{{$ml.get('PROCESSES')}}</a> 
                            </li> 
                            <li class="w-auto text-center bg-crm-tab"> 
                                <a href="#showNotePanel" data-toggle="tab" role="tab" aria-controls="tab" aria-expanded="true">{{$ml.get('NOTES')}}</a> 
                            </li>   
                            <li class="w-auto text-center bg-crm-tab"> 
                                <a href="#showMailPanel" data-toggle="tab" role="tab" aria-controls="tab" aria-expanded="true">{{$ml.get('EMAIL')}}</a> 
                            </li>   
                            <li class="w-auto text-center bg-crm-tab"> 
                                <a href="#specialArea" data-toggle="tab" role="tab" aria-controls="tab" aria-expanded="true">{{$ml.get('SPECIAL_AREA')}}</a> 
                            </li>
                            <li class="w-auto text-center bg-crm-tab"> 
                                <a href="#file" @click="watchUpdated=watchUpdated+1" data-toggle="tab" role="tab" aria-controls="tab" aria-expanded="true">{{$ml.get('FILE')}}</a> 
                            </li>                                                                    
                        </ul>
                        <div class="col-12 bg-white">
                            <div class="row tab-content" style="min-height:200px">
    
                                <div class="col-12 tab-pane active"  id="organizationAll">
                                    <completeShowPanel field="info" :contact="this.contact" :users="users" />
                                </div>
    
                                <div class="col-12 tab-pane"  id="contactDetailPanel">
                                    <organizationDetailPanel :pageIs="dataType" :user="currentUser" :data="organization" v-if="organization.length!=0" />
                                    <div role="alert" class="alert alert-secondary alert-dismissible fade show mt-3" v-else>
                                        {{$ml.get('NO_RELATED_COMPANY')}}
                                    </div>
                                </div>
    
                                <div class="col-12 tab-pane"  id="dealDetailPanel">
                                    <dealDetailPanel :users="users" :user="currentUser" :data="contactDeals" :organization="organization"/>
                                </div>
                                
                                <!-- burası -->
                                <div class="col-12 tab-pane"  id="activitiesDetailPanel">
                                    <activitiesDetailPanel field='orgContact' :contactId="contactId" @updateActivity="updateActivity($event)" :users="users" @refleshData="getContact()" :data="contact.crmActivities"/>

                                    <!-- <p class="lead">{{organization.crmActivities}}</p> -->

                                    <!-- <br><br><br> -->

                                    <!-- <p class="lead">{{contact.crmActivities}}</p> -->
                                </div>

                                <div class="col-12 tab-pane"  id="processesDetailPanel">
                                    <processesDetailPanel :users="users" :dataId="contactId" field='contact' />
                                </div>

                                <div class="col-12 tab-pane"  id="showNotePanel">
                                    <div class="row mt-3">
                                        <div class="col-11 col-md-8 m-auto">
                                            <addNotePanel @updateContactNote="contactNote.push($event)" :data="contact" postField="contact" @getContact="getContact()" />
                                            <showNotePanel field="contact" :data="contactNote" :users="users" :contact="contact" @getContact="getContact()"/>
                                        </div>
                                    </div>
                                </div>
    
                                <div class="col-12 tab-pane"  id="showMailPanel">
                                    <div class="row">
                                        <div class="col-10 m-auto">
                                            <showMailPanel :contactId="contactId" :users="this.users" />
                                        </div>
                                    </div>
                                </div>
    
                                <div class="col-12 tab-pane"  id="specialArea">
                                    <special-area type="profil" postField="contact" @updateData="getContact()"  :users="users" :user="currentUser" :data="contact" :customField="customFields"></special-area>
                                </div>

                                <div class="col-12 tab-pane"  id="file">
                                    <file class="mt-3" 
                                        :customerFiles="customerFiles"
                                        :watchUpdated="watchUpdated"
                                        :showButton="true"
                                        :contactData="contactData"
                                        :contactId="contactId" 
                                        @showCustomerFile="showCustomerFile($event)"
                                        @addNewFile="addNewFile($event)"
                                        @deleteFile="function($event){ 
                                            for(k in this.customerFiles){
                                            if(this.customerFiles[k]['oid']==$event['oid']){
                                            this.customerFiles.splice(k,1)
                                            }
                                         }}"
                                    ></file>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal fade" id="add" ref="vuemodal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document" style="max-width:800px!important">
                    <div class="modal-content mcBgGrey crm-modal-content">
                        <newContact @updateList="getContact()" ref="newContact" @updateData="getContact()" :user="currentUser" :pageIs="dataType" :isEditMode="true" :data="contactData" :users="users" :customFieldArray="customFields" @getContact="getContact"></newContact>
                    </div>
                </div>
            </div>
    
            <div class="modal fade in" id="addOrganizationModal" ref="vuemodal" tabindex="-1" role="dialog" aria-labelledby="addOrganizationModal" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document" style="max-width:750px!important">
                    <div class="modal-content mcBgGrey crm-modal-content">
                        <newOrganization :data="organization" :isEditMode="true" :user="currentUser" :users="users" @updateList="getContact()" :customFieldArray="organizationCustomFields"></newOrganization>
                    </div>
                </div>
            </div>
    
            <div class="modal fade" id="noteAdd" ref="vuemodal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document" style="max-width:750px!important">
                    <div class="modal-content mcBgGrey">
                    <div class="modal-header border-0 mt-2 pb-0 align-items-center">
                        <h5 class="modal-title font-weight-bold" id="exampleModalLongTitle">{{$ml.get('TAKE_NOTE')}}</h5>
                        <button type="button" class="close font-40" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <addNotePanel @updateContactNote="contactNote.push($event)" :data="contact" postField="contact" />
                    </div>
                    </div>
                </div>
            </div>
    
            <div class="modal fade" id="addDeal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document" style="max-width:750px!important">
                    <div class="modal-content crm-modal-content">
                            <newDeal :methods='type' @getData="addDeal($event)" :data="organization" :user="currentUser" :users="users" :customFieldArray="dealscustomFieldArray"></newDeal>
                    </div>
                </div>
            </div>
    
            <div class="modal fade" id="addActivity" ref="newActivity" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document" style="max-width:750px!important">
                    <div class="modal-content crm-modal-content">
                            <newActivity :methods='type' :contact="this.contact" :user="currentUser" :clearModal="clearModal" :listenStateStatus="this.listenStateStatus" :users="users" @refleshData="getContact()" :data="contact" :contactOrg="organization"></newActivity>
                    </div>
                </div>
            </div>
    
            <notifications group="foo" style="margin-right:5%;margin-top:5%" position="top right" />
        </div>
    </div>
</template>
  
  <script>
  import Vue from 'vue'
  import Header from './header'
  import axios from 'axios'
  import {mapState} from 'vuex'
  import {mapActions} from 'vuex'
  import {mapGetters} from 'vuex'
  import _ from 'underscore'
  import specialArea from '@/components/customField'
  import headerPanel from '@/components/headerPanel'
  import contactDetailPanel from '@/components/contactDetailPanel'
  import organizationDetailPanel from '@/components/organizationDetailPanel'
  import showMailPanel from '@/components/showMailPanel'
  import activitiesDetailPanel from '@/components/activitiesDetailPanel'
  import processesDetailPanel from '@/components/processesDetailPanel'
  import completeShowPanel from '@/components/completeShowPanel'
  import dealDetailPanel from '@/components/dealDetailPanel'
  import newActivity from '@/components/newActivity'
  import newOrganization from "@/components/newOrganization.vue"
  import newDeal from '@/components/newDeal'
  import addNotePanel from '@/components/addNotePanel'
  import showNotePanel from '@/components/showNotePanel'
  import newContact from './newContact.vue'
  import File from './file.vue'
  export default {
      name: 'contactCard',
      components: {
          Header,
          'special-area':specialArea,
          'headerPanel':headerPanel,
          'contactDetailPanel':contactDetailPanel,
          'organizationDetailPanel':organizationDetailPanel,
          'activitiesDetailPanel':activitiesDetailPanel,
          'processesDetailPanel':processesDetailPanel,
          'completeShowPanel':completeShowPanel,
          'addNotePanel':addNotePanel,
          'showNotePanel':showNotePanel,
          'dealDetailPanel':dealDetailPanel,
          'newActivity':newActivity,
          'showMailPanel':showMailPanel,               
          'newDeal':newDeal,           
          "newContact":newContact,    
          "newOrganization":newOrganization,
           File,    
      },
      data () {
      return {
              clearModal:false,
              deal:[],
              activities:[],
              contact:[],
              organization:[],
              contactsId:"",
              users:[],
              items:[],
              customFields:[],
              currentUser:[],
              stateId:"",
              search:"",
              isHiddenTitle:false,
              isHiddenValue:false,
              isHiddenAddr:false,
              isHiddenPhone:false,
              updateContactPhoneText:"",
              updateContactEmailText:"",
              dealLoseSelect:0,
              dealLoseInput:"",
              selected: undefined,
              isActive:false,
              type:"save",
              dataType:"contact",
              contactNote:[],
              organizationNote:[],
              permissions:[],
              organizationId:null,
              dealscustomFieldArray:[],
              contactData:[],
              isEditMode:true,
              organizationCustomFields:[],
              contactDeals:[],
              customerFiles:[],
              watchUpdated:0
          }
      },
      computed:{
          listenState() {
              return this.$store.state.editLine;
          },
          listenStateStatus() {
              return this.$store.state.editLineStatu;
          },
          ...mapState([
              'baseUrl',
              'editLineStatu'
          ]),
          ...mapGetters(['ownerId'])
      },
      beforeMount() {
        if(!this.isOwner&&!this.$can('can_see_other_users_contacts')){
            this.$router.push('/contacts')
        }
      },
      methods:{
          isOwner(){
                if(this.contact.cuid){
                    return this.ownerId==this.contact.cuid.$oid
                }
          },
          addDeal(deal){
              this.contact.deals.push(deal)
          },
          editContact(){
              this.$refs.newContact.oldData()
              this.isEditMode=true
              $("#add").modal("show")
          },
          getContact(){
              axios({
                  method:'POST',
                  url:'/getContact',
                  baseURL: this.baseUrl,
                  data: {
                      contactId:this.contactId,
                  },
                  withCredentials:true
              }).then((res)=>{
                  return res
              }).then((res)=>{
                  if(res.data.status===false){
                      this.$router.push('/logout')
                  }
                  if(res.data.status.code==0){
                      this.contactDeals=res.data.content.contact.deals
                      this.contact=res.data.content.contact
                      this.contactData=res.data.content.contact
                      this.$delete(this.contactData, 'deals')
                     //this.activities=res.data.content.organization.crmActivities
                      this.users=res.data.users
                      this.currentUser=res.data.user
                      this.customFields=res.data.content.customFields
                      if(res.data.permissions!==undefined){
                          this.permissions=res.data.permissions
                      }else{
                          this.permissions=[]
                      }
                      if(res.data.content.contact.notes!==undefined){
                          this.contactNote=res.data.content.contact.notes
                      }else{
                          this.contactNote=[]
                      }
                      if(this.contact.organization!==undefined &&  this.contact.organization.length>0){
                          this.getOrganization(this.contact.organization[0]._id.$oid)
                      }
                       
                  }else{
                      this.$notify({ 
                          group: 'foo',
                          type: 'error', 
                          title: this.$ml.get('ERROR'),
                          text: res.data.status.desc 
                      })
                       
                  }
              })
          },
          getOrganization(id){
               
              axios({
                  method:'POST',
                  url:'/getOrganization',
                  baseURL: this.baseUrl,
                  data: {
                      organizationId:id,
                  },
                  withCredentials:true
              }).then((res)=>{
                  return res
              }).then((res)=>{
                  if(res.data.status===false){
                  this.$router.push('/logout')
                  }
                  if(res.data.status.code==0){
                      this.organization=res.data.content.organization
                      this.organizationCustomFields=res.data.content.customFields
                      this.organizationId=res.data.content.organization._id.$oid
                      this.activities=res.data.content.organization.crmActivities
                      this.users=res.data.users
                      this.currentUser=res.data.user
                      //this.customFields=res.data.content.customFields
                      if(res.data.content.organization.notes!==undefined){
                          this.organizationNote=res.data.content.organization.notes
                      }else{
                          this.organizationNote=[]
                      }
                       
                  }else{
                      this.$notify({ 
                          group: 'foo',
                          type: 'error', 
                          title: this.$ml.get('ERROR'),
                          text: res.data.status.desc 
                      })
                       
                  }
              })
          },
          getDealsCustomField(){
              //if(this.active===false){
                  axios({
                      method:'POST',
                      url:`/getCustomFields`,
                      baseURL: this.baseUrl,
                      data:{
                          domain:1
                      },
                      withCredentials:true
                  }).then((res)=>{
                      return res
                  }).then((res)=>{
                      if(res.data.status.code==0){
                          this.dealscustomFieldArray = res.data.content.customFields
                      }
                      
                  })
          // }
              
          },
          updateActivity(data){
              data["edit"]=true
              this.$store.dispatch('editLine', data)
              let statu=true
              this.$store.dispatch('editLineStatu', statu)
          },
          activityModalHidden(){
              let statu=false
              this.$store.dispatch('editLineStatu', statu)
              this.clearModal=true
          },
          ...mapActions([
              'updateLoading'
          ]),
            showCustomerFile(event){
            this.customerFiles=event
        },
        addNewFile(event){
            // this.fileId=event
            this.customerFiles.unshift(event) 
        },
      },
  
      mounted(){
          $(this.$refs.newActivity).on("hidden.bs.modal", this.activityModalHidden)
          $(".mincrm-dynamic-tabs").bootstrapDynamicTabs();
      },
      created(){
          this.contactId = this.$route.params.contactId
          this.getContact()
          this.getDealsCustomField()
      },
      watch:{
          organization:function(value){
              this.organization=value
          }
      }
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  
  .dealLosePopup input{
      border: 1px;
      height: 45px;
  }
  .username {
      font-family: "font-family-regular";
      font-size: 12px;
  }
  .company {
      font-family: "font-family-regular";
      font-size: 10px;
  }
  .updateInput{
      border: 0px;
      border-bottom: 1px solid #66D0FF80;
  }
  .deal-panel {
    border: 1.2px solid #66D0FF;
    border-radius: 50px;
  }
  .deal-title {
    font-family: 'font-family-bold';
    font-size: 18px;
  }
  .dealStatus div:first-child {
    margin-left: 0px;
    z-index: 9;
  }
  .dealStatus div:last-child {
    z-index: 2;
  }
  .dealStatus div {
    margin-left: -30px;
  }
  .dealStatus div button {
    font-family: "font-family-bold";
    border-radius: 20px;
    background-color: white;
    height: 32px;
    border: 1px solid #66D0FF80;
    color: #66D0FF;
    font-weight: normal;
    font-size: 13px;
  }
  .btn-type-1 button{
    font-family: "font-family-bold";
    border-radius: 20px;
    background-color: white;
    height: 27px;
    border: 1px solid #66D0FF80;
    color: #66D0FF;
    font-weight: normal;
    font-size: 10px;
  }
  .dealBtnStyle button {
    font-family: "font-family-bold";
    border-radius: 20px;
    background-color: white;
    height: 36px;
    border: 1px solid #3767a080;
    color: #3767a0;
    font-weight: normal;
    font-size: 14px;
  }
  .dealBtnStyle button.active {
    background-color: #3767a0!important;
    border: 1px solid #3767a0;
    color: white;
  }
  .dealStatus label {
    font-family: "font-family-bold";
    font-weight: normal;
    font-size: 10px;
    color: gray;
    padding-left: 25px;
  }
  .dealStatus .active {
    border-color: #59d816!important;
    color: #59d816!important;
    font-family: "font-family-bold";
    font-weight: normal;
    font-size: 14px;
  }
  .dealConfig button {
    font-family: "font-family-bold";
    font-weight: normal;
    font-size: 14px;
    border-radius: 20px;
    border: 1px solid #66D0FF80;
    color: #66D0FF;
    background-color: transparent;
  }
  
  .dealCenter label {
    font-family: "font-family-regular";
    font-size: 14px;
  }
  .dealCenterUl li {
    font-size: 14px;
  }
  .dealCenterUl li a {
  color: #93959A;
  text-decoration: none;
  height: 100%;
  display: flex;
  align-items: center;
  padding: 0 13px;
  }
  .dealCenterUl li a.active {
    color: #1991eb;
    background-color: #E8F4FD;
    font-weight: bold;
    border-bottom: 3px solid #1991EB;
  }
  .dealCenterNavBar li a.active{
    background-color: #66D0FF30!important;
  }
  .info-hide {
    font-family: "font-family-bold";
    font-weight: normal;
    font-size: 10px;
    text-transform: uppercase;
  }
  .dealCartStatus hr {
    border: 1px solid #66D0FF40!important;
    width: 100%!important;
  }
  .dealCartStatus .active {
    border: 1px solid #66D0FF!important;
  }
  .iptal:before{
      color:red
  }
  .add,.edit:hover{
      cursor: pointer;
  }
  .add:hover:after{
      content: "\e952";
      font-size: 14px;
      margin-left: 0.5em;
      font-family: 'icomoon' !important;
      color: #66D0FF;
  }
  .edit:hover:after{
      content: "\e913";
      font-size: 14px;
      margin-left: 0.5em;
      font-family: 'icomoon' !important;
      color: #66D0FF;
  }
  .hide{
      display: none
  }
  .hide_visible {
      visibility: hidden;
  }
  .show{
      visibility: visible;
  }
  .field:hover .icon-line-duzenle{
      visibility: visible;
  } 
  .mincrm-dynamic-tabs{
      border-bottom: 1px solid #dcdddd;
  }
  @media (max-width: 768px){
    .dealCenterUl li a.active {
        color: #fff;
        font-weight: bold;
        background-color: #1991eb;
        border-bottom: 3px solid #1991EB;
    }   
}
  </style>
